import { authFetch, BASE_BACKEND_URL } from '../auth'
import React, { useEffect, useState } from 'react'
import cookie from 'react-cookies'
import AttributeView from './attributes/AttributeView'
import SegmentContext from './context/SegmentContext'
import DetailsView from './details/DetailsView'
import LoadingScreen from '../components/LoadingScreen'

export default function SegmentIndexView(props) {
  const tabs = ['Atributos', 'Detalles']

  const getSelectedTab = () => {
    const searchParams = new URLSearchParams(window.location.search)
    let selected_tab = searchParams.get('selected_tab')
    return selected_tab || tabs[0]
  }

  const initPaginationData = () => {
    const searchParams = new URLSearchParams(window.location.search)
    let page = searchParams.get('page')
    let currentPage = page ? Number(page) : 1
    if (!page) {
      searchParams.set('page', '1')
      let newRelativePathQuery = `${window.location.pathname}?${searchParams}`
      window.history.pushState(null, '', newRelativePathQuery)
    }
    return { per_page: 50, current_page: currentPage, total_pages: 1, query: '' }
  }

  const [selectedTab, setSelectedTab] = useState(getSelectedTab())
  const [qualifiersData, setQualifiersData] = useState(null)
  const [clientsData, setClientsData] = useState(null)
  const [promoQualifiersData, setPromoQualifiersData] = useState(null)
  const [fetchDataStatus, setFetchDataStatus] = useState({})
  const [qualifierQuery, setQualifierQuery] = useState(null)
  const [searchQuery, setSearchQuery] = useState(null)
  const [pagination, setPagination] = useState(initPaginationData())
  const [isFetching, setIsFetching] = useState(true)

  const abortController = new AbortController()
  const abortCurrentFetchs = () => abortController.abort('Fetch Aborted by User.')
  window.addEventListener('beforeunload', abortCurrentFetchs)

  useEffect(() => {
    async function fetchAll() {
      setIsFetching(true)
      await fetchQualifiersFromServer()
      await fetchPromoQualifiers()
      setIsFetching(false)
    }
    fetchAll()
  }, [])

  useEffect(() => {
    if (selectedTab === 'Detalles') {
      updateURLPaginationData()
      async function fetchClients() {
        setIsFetching(true)
        await fetchClientsFromServer()
        setIsFetching(false)
      }
      fetchClients()
    }
  }, [pagination.current_page, qualifierQuery, searchQuery])

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set('selected_tab', selectedTab)
    let newRelativePathQuery = `${window.location.pathname}?${searchParams}`
    window.history.pushState(null, '', newRelativePathQuery)
  }, [selectedTab])

  const getListTabStyles = tab => (selectedTab === tab ? 'active' : 'nav-item')
  const getAnchorTabStyles = tab => (selectedTab === tab ? 'active' : 'inactive-tab')

  const fetchQualifiersFromServer = async (loadingState = true) => {
    if (loadingState) setFetchDataStatus(prev => ({ ...prev, qualifiers: true }))
    try {
      const response = await authFetch(
        `${BASE_BACKEND_URL}/qualifiers`,
        {
          method: 'GET',
          signal: abortController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
      if (response.status === 401) return console.error(response)
      const data = await response.json()
      setQualifiersData(data)
    } catch (error) {
      if (error !== 'Fetch Aborted by User.') console.error('Error:', error)
    } finally {
      setFetchDataStatus(prev => ({ ...prev, qualifiers: false }))
    }
  }

  const fetchClientsFromServer = async () => {
    setFetchDataStatus(prev => ({ ...prev, clients: true }))
    const { per_page, current_page } = pagination
    try {
      const response = await authFetch(
        `${BASE_BACKEND_URL}/clients?page=${current_page}&per_page=${per_page}${qualifierQuery || ''}${searchQuery || ''}`,
        {
          method: 'GET',
          signal: abortController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
      if (response.status === 401) return console.error(response)
      const data = await response.json()
      setPagination(prev => ({ ...prev, total_pages: Math.ceil(data['count'] / per_page) }))
      setClientsData(data['table'])
    } catch (error) {
      if (error !== 'Fetch Aborted by User.') console.error('Error:', error)
    } finally {
      setFetchDataStatus(prev => ({ ...prev, clients: false }))
    }
  }

  const fetchPromoQualifiers = async () => {
    setFetchDataStatus(prev => ({ ...prev, promoQualifiers: true }))
    try {
      const response = await authFetch(`${BASE_BACKEND_URL}/promo_qualifiers`, {
        method: 'GET',
        signal: abortController.signal,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      })
      if (response.status === 401) return console.error(response)
      const data = await response.json()
      setPromoQualifiersData(data.result)
    } catch (error) {
      if (error !== 'Fetch Aborted by User.') console.error('Error:', error)
    } finally {
      setFetchDataStatus(prev => ({ ...prev, promoQualifiers: false }))
    }
  }

  const handlePaginationClick = event => {
    let target = event.target
    if (target.tagName === 'svg') target = target.parentNode
    if (target.tagName === 'path') target = target.parentNode.parentNode
    const id = target.id
    switch (id) {
      case 'first-page':
        if (pagination.current_page !== 1)
          setPagination(prev => ({ ...prev, current_page: 1 }))
        break
      case 'last-page':
        if (pagination.current_page !== pagination.total_pages)
          setPagination(prev => ({ ...prev, current_page: pagination.total_pages }))
        break
      case 'previous-page':
        if (pagination.current_page > 1)
          setPagination(prev => ({ ...prev, current_page: prev.current_page - 1 }))
        break
      case 'next-page':
        if (pagination.current_page < pagination.total_pages)
          setPagination(prev => ({ ...prev, current_page: prev.current_page + 1 }))
        break
    }
  }

  const updateURLPaginationData = () => {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set('page', pagination.current_page)
    let newRelativePathQuery = `${window.location.pathname}?${searchParams}`
    window.history.pushState(null, '', newRelativePathQuery)
  }

  if (isFetching) {
    return (
      <LoadingScreen text="Cargando..." />
    )
  }

  return (
    <>
      <div className="index-header">
        <h2 className="mb-20 float-unset">Segmentos</h2>
      </div>
      <div className="index-table">
        <div className="show-area">
          <div id="tabs">
            <div className="mb-1">
              <ul className="nav nav-tabs">
                {tabs.map((value, index) => (
                  <li
                    key={index}
                    onClick={() => setSelectedTab(value)}
                    id="details_tab"
                    className={`nav-link ${getListTabStyles(value)} cursor-pointer`}
                  >
                    <a className={getAnchorTabStyles(value)} style={{ textDecoration: 'none' }}>
                      {value}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <SegmentContext.Provider
            value={{
              qualifiersData,
              fetchDataStatus,
              clientsData,
              promoQualifiersData,
              pagination,
              setQualifierQuery,
              setSearchQuery,
              searchQuery,
              qualifierQuery,
              fetchQualifiersFromServer,
              fetchClientsFromServer,
              handlePaginationClick
            }}
          >
            <div>
              {selectedTab === 'Atributos' && <AttributeView setIsUpdating={props.setIsUpdating} />}
            </div>
            <div>{selectedTab === 'Detalles' && <DetailsView />}</div>
          </SegmentContext.Provider>
        </div>
      </div>
    </>
  )
}
